export default {
  methods: {
    showErrorDialog(e) {
      // eslint-disable-next-line no-console
      console.log('errorDialog:', e.response);

      let title = this.$t('errors.default.title');
      let message = this.$t('errors.default.message', { error: e.message });

      // Check for error messages from API
      // @todo translations
      if (e.response?.data?.messages) {
        message = e.response.data.messages;
      }

      // No connection error
      if (e.message === 'Network Error') {
        title = this.$t('errors.networkError.title');
        message = this.$t('errors.networkError.message');
      }

      this.$q.dialog({
        title,
        message,
      });
    },
  },
};
